namespace Nbs.Xlr8PageTemplate.Header {
  export function showHeaderMenu(headerLink: HTMLElement) {
    // The event target might be a child of the element we want
    const button = Utilities.findParent(headerLink, e => e.tagName.toUpperCase() === 'BUTTON' || e.tagName.toUpperCase() === 'A');
    if (button) {
      const menu = button.nextElementSibling as HTMLElement;
      if (menu) {
        if (!menu.classList.contains('xpt-hidden')) {
          menu.classList.add('xpt-hidden');
        } else {
          hideAllHeaderMenus();
          menu.style.left = '0px';
          const buttonRect = button.getBoundingClientRect();
          const menuRect = menu.getBoundingClientRect();
          const leftOffset = 3;
          const menuLeft = (buttonRect.left + buttonRect.width) - (menuRect.width) + leftOffset;
          menu.style.top = `${shouldDisplayLargeHeader() ? largeHeaderMenuHeight + largeHeaderBottomBorderWidth : headerMenuHeight + headerBottomBorderWidth}px`;
          menu.style.left = `${menuLeft}px`;
          menu.classList.remove('xpt-hidden');
        }
        headerLink.setAttribute('aria-expanded', 'true');
      }
    }
  }

  export function hideAllHeaderMenus() {
    const menus = document.getElementsByClassName('xpt-header-menu-container');
    Array.prototype.forEach.call(menus, (menu: HTMLElement) => {
      menu.classList.add('xpt-hidden');
      const menuLink = menu.closest('.xpt-header-link')?.querySelector('a');
      menuLink?.setAttribute('aria-expanded', 'false');
    });
  }

  export function closeSubMenu(event: Event) {
    const menu = (event.target as HTMLElement).closest('.xpt-header-link') as HTMLElement;
    if (!menu) {
      hideAllHeaderMenus();
    }
  }

  export function setHeaderSize(){
    Header.expandCollapseHeader();
  }
}
